import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import dayjs from "dayjs";
import parse from 'html-react-parser';
import { GetPackagesResult } from "api/hooks/public/useGetPackages";

interface PropTypes {
    section: GetPackagesResult['courses'][0]['sections'][0];
    selected: boolean;
    onSelect: (section_id: string) => void;
}

function SectionListItem({ section, selected, onSelect }: PropTypes) {
    // const theme = useTheme();
    // const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    //     defaultMatches: true,
    // });

    const getCapacityColor = (seats_left: number) => {
        if (seats_left < 10) {
            return "error.main"
        }

        if (seats_left < 20) {
            return "warning.main"
        }

        return "success.main"
    };


    return (

        <ListItem
            key={section.id}
            secondaryAction={
                <IconButton edge="end">
                    {/* <CommentIcon /> */}
                </IconButton>
            }
            disablePadding
        >
            <ListItemButton
                role={undefined}
                // onClick={handleToggle(value)}
                onClick={() => onSelect(section.id)}
                dense
                disabled={section?.seats_left === 0}
                selected={selected}
            >
                <ListItemIcon>
                    <Radio
                        edge="start"
                        checked={selected}
                        tabIndex={-1}
                        disableRipple
                    />
                </ListItemIcon>
                {/* <ListItemText id={section.id} primary={section?.title} secondary={`${section.seats_left} Seats Left`} /> */}
                <ListItemText
                    id={section.id}
                    disableTypography
                    primary={<Typography variant="h6">{section?.title}</Typography>}
                    primaryTypographyProps={{
                        variant: 'h6'
                    }}
                    secondary={
                        <>
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                // color={section.seats_left < 10 ? 'error' : 'success'}
                                color={getCapacityColor(section.seats_left)}
                            >
                                {section.seats_left > 0 && `${section.seats_left} Seats Remaining`}
                                {section.seats_left == 0 && 'This Section Is Full'}
                            </Typography>
                            {section?.description && (
                                <Typography component={'p'} pb={2}>
                                    {parse(section?.description)}
                                </Typography>
                            )}
                            <Typography
                                variant="body2"
                                fontWeight="bold"
                                component="ul"
                            // color={section.seats_left < 10 ? 'error' : 'success'}
                            // color={getCapacityColor(section.seats_left)}
                            >
                                {section?.periods?.map((period) => (
                                    <li key={period.id}>
                                        {dayjs(period.start).format('MMM DD h:mm A')} - {dayjs(period.end).format('LT')}
                                    </li>
                                ))}
                            </Typography>
                        </>
                    }
                />
            </ListItemButton>
        </ListItem>

    );
}

export default SectionListItem;